export default __webpack_public_path__ + "static/media/add.89304e34.svg";